import {
  IFRAME_POSTMESSAGE_TYPE,
  WEBVIEW_MESSAGE_TYPE,
} from '@/types/post-message.types';

class BrowserEventService {
  navigateToPdp(data: string) {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.PDP_NAVIGATION,
      data: data,
    });
  }

  redirectToLoginPage() {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.REDIRECT_TO_LOGIN_PAGE,
      data: {},
    });
  }

  scrollToTop() {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SCROLL_TO_TOP,
    });
  }

  setIframeHeight(height: number) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SET_HEIGHT,
      height,
    });
  }

  setAutoCompleteIframeHeight(height: number) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SET_AUTO_COMPLETE_HEIGHT,
      height,
    });
  }

  setQueryInIframe(query: string) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SET_QUERY,
      query,
    });
  }

  setAutoCorrectIframe(autoCorrect: { autoCorrect: boolean; query: string }) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SET_AUTO_CORRECT,
      autoCorrect,
    });
  }

  handleScrollForFilter(filterEvent: boolean) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.FILTER_EVENT,
      filter: filterEvent,
    });
  }

  pageChanged(page: number, query?: string) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.PAGE_CHANGED,
      page,
      ...(query !== undefined ? { query } : {}),
    });
  }

  filterChanged(
    facet: Record<string, string[] | string>,
    currentPage: number,
    query?: string
  ) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.FILTER_CHANGED,
      facet: facet,
      currentPage: currentPage,
      ...(query !== undefined ? { query } : {}),
    });
  }

  cartUpdate(productId: string, quantity: number) {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.CART_ITEM_CHANGED,
      product: { productId: productId, quantity: quantity },
    });
  }

  iframeReady() {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.IFRAME_READY,
    });
  }

  private postMessage(eventData: unknown) {
    window?.parent.postMessage(eventData, '*');
  }
}
const SendBrowserEvent = new BrowserEventService();

export default SendBrowserEvent;
